// import { MaterialReactTable } from "material-react-table";
// import { getImageUrl } from "utils/imageHelper";


// export default function ProductCategoryTable({
//   data = [],
//   loading,
//   onEdit,
//   onDelete,
// }) {
//   const columns = [
//     { accessorKey: "title", header: "Category Name" },
//     {
//       accessorKey: "image",
//       header: "Image",
//       Cell: ({ cell }) => {
//         const value = cell.getValue();
//         return value ? (
//           <img
//             src={getImageUrl(value)}
//             alt="Category"
//             className="h-12 w-12 rounded border object-cover"
//           />
//         ) : (
//           "-"
//         );
//       },
//     },
//     {
//       header: "Actions",
//       Cell: ({ row }) => (
//         <div className="flex gap-2">
//           <button
//             onClick={() => onEdit(row.original)}
//             className="rounded bg-yellow-100 px-3 py-1 text-xs text-yellow-700"
//           >
//             Edit
//           </button>
//           <button
//             onClick={() => {
//               if (window.confirm(`Delete category "${row.original.title}"?`)) {
//                 onDelete(row.original);
//               }
//             }}
//             className="rounded bg-red-100 px-3 py-1 text-xs text-red-700"
//           >
//             Delete
//           </button>
//         </div>
//       ),
//     },
//   ];

//   const flattenForExport = (rows, level = 0) => {
//   let result = [];

//   rows.forEach((row) => {
//     const { children, ...rest } = row;

//     result.push({
//       ...rest,
//       __level: level, // for indentation (optional)
//     });

//     if (children?.length) {
//       result = result.concat(flattenForExport(children, level + 1));
//     }
//   });

//   return result;
// };


//   const handleExportCsv = () => {
//   const flatData = flattenForExport(data);

//   const headers = columns
//     .filter((c) => c.accessorKey)
//     .map((c) => c.header);

//   const rows = flatData.map((row) =>
//     columns
//       .filter((c) => c.accessorKey)
//       .map((col) => {
//         let value = row[col.accessorKey] ?? "";

//         if (col.accessorKey === "title" && row.__level > 0) {
//           value = `${"— ".repeat(row.__level)}${value}`;
//         }

//         return `"${String(value).replace(/"/g, '""')}"`;
//       })
//       .join(",")
//   );

//   const csvContent = "\uFEFF" + [headers.join(","), ...rows].join("\n");

//   const blob = new Blob([csvContent], {
//     type: "text/csv;charset=utf-8;",
//   });

//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", "categories.csv");
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };


//   return (
//     <>
//       <div className="mb-3 flex justify-end">
//         {/* <button
//           onClick={handleExportCsv}
//           className="rounded bg-green-500 px-3 py-1 text-xs text-white"
//         >
//           Export CSV
//         </button> */}
//       </div>

//       <MaterialReactTable
//         columns={columns}
//         data={data}
//         state={{ isLoading: loading }}
//         enableExpanding
//         getSubRows={(row) => row.children}
//         muiTableBodyRowProps={{ hover: true }}
//         enableGlobalFilter={false}
//       />
//     </>
//   );
// }

import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import ImageViewer from "components/common/ImageViewer";
import {
  MdMoreVert,
  MdEdit,
  MdDelete,
  MdChevronRight,
  MdExpandMore,
} from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";

function TreeRow({
  item,
  level = 0,
  onEdit,
  onAskDelete,
  openViewer,
  openDropdownId,
  setOpenDropdownId,
  openUpward,
  setOpenUpward,
  dropdownRef,
}) {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = Array.isArray(item.children) && item.children.length > 0;
  const isMenuOpen = openDropdownId === item._id;

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    if (isMenuOpen) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(item._id);
    }
  };

  return (
    <>
      <tr className="custom-table-row">
        {/* Category Name (Indented with Expand Icon) */}
        <td className="custom-table-cell">
          <div
            className="flex items-center gap-1"
            style={{ paddingLeft: `${level * 24}px` }}
          >
            {hasChildren ? (
              <button
                type="button"
                onClick={() => setExpanded(!expanded)}
                className="p-1 text-gray-500 hover:text-gray-800"
              >
                {expanded ? (
                  <MdExpandMore className="text-lg" />
                ) : (
                  <MdChevronRight className="text-lg" />
                )}
              </button>
            ) : (
              <span className="w-6 inline-block" />
            )}

            <span className="font-medium text-gray-800">
              {item.title || "N/A"}
            </span>

            {hasChildren && (
              <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-500">
                {item.children.length}
              </span>
            )}
          </div>
        </td>

        {/* Category Image */}
        <td className="custom-table-cell">
          {item.image ? (
            <img
              src={getImageUrl(item.image)}
              alt={item.title}
              className="table-logo cursor-pointer"
              onClick={() => openViewer(getImageUrl(item.image))}
            />
          ) : (
            <span style={{ fontSize: "10px", color: "#d1d5db" }}>
              No image
            </span>
          )}
        </td>

        {/* Action Dropdown Menu Cell */}
        <td className="custom-table-cell relative text-center">
          <button onClick={handleToggleMenu} className="action-menu-btn">
            <MdMoreVert className="text-lg" />
          </button>

          {isMenuOpen && (
            <div
              ref={dropdownRef}
              className={`action-dropdown-menu ${
                openUpward ? "menu-bottom" : "menu-top"
              }`}
            >
              <button
                onClick={() => {
                  onEdit(item);
                  setOpenDropdownId(null);
                }}
                className="action-dropdown-item"
              >
                <MdEdit className="text-base" />
                Edit
              </button>

              <div className="action-dropdown-divider" />

              <button
                onClick={() => {
                  onAskDelete(item);
                  setOpenDropdownId(null);
                }}
                className="action-dropdown-item"
              >
                <MdDelete className="text-base" />
                Delete
              </button>
            </div>
          )}
        </td>
      </tr>

      {/* Render Child Subcategories recursively */}
      {hasChildren &&
        expanded &&
        item.children.map((childNode) => (
          <TreeRow
            key={childNode._id}
            item={childNode}
            level={level + 1}
            onEdit={onEdit}
            onAskDelete={onAskDelete}
            openViewer={openViewer}
            openDropdownId={openDropdownId}
            setOpenDropdownId={setOpenDropdownId}
            openUpward={openUpward}
            setOpenUpward={setOpenUpward}
            dropdownRef={dropdownRef}
          />
        ))}
    </>
  );
}

export default function ProductCategoryTable({ data = [], onEdit, onDelete }) {
  const [deleteRow, setDeleteRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerSrc, setViewerSrc] = useState(null);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteRow);
      setDeleteRow(null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              <th>Category Name</th>
              <th>Image</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="3"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No categories found
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <TreeRow
                  key={item._id}
                  item={item}
                  level={0}
                  onEdit={onEdit}
                  onAskDelete={setDeleteRow}
                  openViewer={(src) => {
                    setViewerSrc(src);
                    setViewerOpen(true);
                  }}
                  openDropdownId={openDropdownId}
                  setOpenDropdownId={setOpenDropdownId}
                  openUpward={openUpward}
                  setOpenUpward={setOpenUpward}
                  dropdownRef={dropdownRef}
                />
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteRow)}
        title="Delete Category"
        message={`Are you sure you want to delete category "${deleteRow?.title}"? This action cannot be undone.`}
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteRow(null)}
      />

      {/* Image Previewer */}
      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerSrc}
      />
    </>
  );
}